import { type JSX, type ReactNode } from 'react';

import { Scrollable } from '@cx-modules/ui';

import { OffersBarContainer, tooltipScrollContainer } from './style';

export const OffersPortalWithScroll = ({
  children,
  coordinates,
  isScrollableCallback,
}: {
  children: ReactNode;
  coordinates: {
    x: string;
    y: string;
  };
  isScrollableCallback: () => boolean;
}): JSX.Element => {
  return (
    <OffersBarContainer {...coordinates}>
      <Scrollable isScrollableCallback={isScrollableCallback} outerClass={tooltipScrollContainer}>
        {children}
      </Scrollable>
    </OffersBarContainer>
  );
};
